import React from "react";

const StaffAppFeatures = ({ title, subtitle, features }) => {
  return (
    <section className="w-full bg-[#FFFFFF] py-10 px-6 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center">
          <h2 className="text-[#10324F] text-xl sm:text-3xl font-bold uppercase min-h-12">
            {title}
          </h2>

          <p className="mt-4 text-base leading-6 text-[#10324F]">{subtitle}</p>
        </div>

        {/* Cards */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((item, index) => (
            <div
              key={index}
              className="
                rounded-xl
                border-2 border-[#AEAEC014]
                min-h-55 sm:min-h-60
                flex flex-col
                items-start
                p-6 w-full
                backdrop-blur-[15px]
              "
              style={{
                boxShadow: `
                  rgb(167 191 210 / 40%) -15px -15px 20px inset,
                  rgb(170 188 202 / 30%) -20px -20px 30px
                `,
              }}
            >
              {/* Icon */}
              <div className="w-14 h-14 rounded-xl bg-[#f5f8fc] flex items-center justify-center text-[#10324F] shadow-sm mb-5">
                {item.icon}
              </div>

              <h2 className="text-[#10324F] text-lg font-semibold">
                {item.title}
              </h2>

              <p className="mt-3 text-sm text-[#10324F]">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StaffAppFeatures;
